import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { colors, fontMono, s } from "../lib/theme";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [callsign, setCallsign] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(callsign, password);
      navigate("/actividades");
    } catch (err) {
      setError(err.message || "No se pudo iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "60px 20px" }}>
      <div style={{ width: 380, background: colors.panelRaised, border: `1px solid ${colors.lineStrong}`, borderRadius: 14, padding: "34px 32px" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}>
          <img src="/brand/icon-flat-white.svg" alt="Centinel DX" width={48} height={48} />
        </div>
        <div style={{ textAlign: "center", fontSize: 22, fontWeight: 700, letterSpacing: "0.06em", color: colors.text }}>
          CENTINEL DX
        </div>
        <div style={{ textAlign: "center", fontSize: 10.5, fontWeight: 700, letterSpacing: "0.12em", color: colors.textFaint, marginBottom: 26 }}>
          GESTIÓN DE ACTIVIDADES DE RADIOAFICIÓN
        </div>

        <form onSubmit={submit}>
          <label style={s.label}>INDICATIVO</label>
          <input
            style={{ ...s.input, fontSize: 16, fontWeight: 600, textTransform: "uppercase", marginBottom: 14 }}
            value={callsign}
            onChange={(e) => setCallsign(e.target.value)}
            placeholder="EA1RFF"
            autoFocus
            autoComplete="username"
          />
          <label style={s.label}>CONTRASEÑA</label>
          <input
            style={{ ...s.input, fontSize: 16, fontWeight: 600 }}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />

          {error && <div style={{ ...s.errorBox, marginTop: 16, marginBottom: 0 }}>{error}</div>}

          <button
            type="submit"
            disabled={loading}
            style={{ ...s.btnPrimary, width: "100%", justifyContent: "center", marginTop: 22, opacity: loading ? 0.6 : 1 }}
          >
            {loading ? "Entrando…" : "ENTRAR"}
          </button>
        </form>
      </div>
    </div>
  );
}
